import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import cn from 'classnames';
import { useRef } from 'react';

import ContentBox from 'components/landing/ContentBox';
import LandingPageImage from 'components/landing/LandingPageImage';

import css from 'styles/components/landing/zapposHero.scss';

const carouselDecorators = [
  {
    position: 'BottomCenter',
    component: ({ slideCount, currentSlide, goToSlide }) => {
      const dots = [];
      for (let i = 0; i < slideCount; i++) {
        dots.push(
          <li key={i}>
            <button type="button" onClick={() => goToSlide(i)} className={cn({ [css.active]: i === currentSlide })}>
              Go to slide {i + 1}
            </button>
          </li>
        );
      }
      return (
        <ul className={css.sliderDots}>
          {dots}
        </ul>
      );
    }
  }
];

const makeHero = (item, slotName, componentName, onLandingComponentClick, shouldLazyLoad) => {
  const {
    cta,
    heading,
    link,
    subheading,
    transparent,
    src,
    mobilesrc,
    tabletsrc,
    retina,
    mobileretina,
    tabletretina,
    alt,
    type
  } = item;
  const imageProps = { src, mobilesrc, tabletsrc, retina, mobileretina, tabletretina, alt, shouldLazyLoad };
  return (
    <div
      className={css.hero}
      key={src || link || heading || cta}>
      <LandingPageImage {...imageProps} />
      {(heading || subheading || cta || link) &&
        <div className={cn(
          css.content,
          { [css.typeProd] : type === 'prod' },
          { [css.notTransparent]: transparent === 'false' }
        )}>
          <ContentBox slotDetails={item} componentName={componentName} onLandingComponentClick={onLandingComponentClick} />
        </div>
      }
    </div>
  );
};

const ZapposHero = ({ slotName, slotDetails: { hero, monetateId, componentName }, onLandingComponentClick, shouldLazyLoad }) => {

  const carouselRef = useRef(null);

  // Nuka doesn't correctly set the height to the max of it's children, so we manually call setDimensions() on load to properly resize
  const asyncResize = () => {
    setTimeout(() => carouselRef.current?.setDimensions(), 0);
  };

  let contents = hero.map(v => makeHero(v, slotName, componentName, onLandingComponentClick, shouldLazyLoad, asyncResize));

  if (hero.length > 1) {
    // Using nuka 3.2  https://www.npmjs.com/package/nuka-carousel/v/3.2.0
    contents = (
      <Carousel
        ref={carouselRef}
        decorators={carouselDecorators}
        autoplay={true}
        autoplayInterval={5000}
        pauseOnHover={true}
        dragging={true}
        swiping={true}
        wrapAround={true}>
        {contents}
      </Carousel>
    );
  }

  return (
    <div
      className={css.container}
      onLoad={asyncResize}
      data-slot-id={slotName}
      data-monetate-id={monetateId}>
      {contents}
    </div>
  );
};

ZapposHero.contextTypes = {
  testId: PropTypes.func
};

export default ZapposHero;
